import { useMutation } from '@apollo/client';
import Cookies from 'js-cookie';

import {
  ACCESS_TOKEN_COOKIE,
  REFRESH_TOKEN_COOKIE,
  NONCE_COOKIE,
  FANATICS_TENANT_ID_COOKIE,
} from '../../Auth';
import { logoutMutation } from '../../gql';

export const collectLogout = (baseUrl: string) => {
  const url = new URL(baseUrl);
  const cookieDomain = url.hostname.startsWith('www.')
    ? url.hostname.replace('www.', '.')
    : `.${url.hostname}`;

  const cookieOptions = {
    path: '/',
    domain: cookieDomain,
    secure: true,
    SameSite: 'None',
  };

  Cookies.remove(ACCESS_TOKEN_COOKIE, cookieOptions);
  Cookies.remove(REFRESH_TOKEN_COOKIE, cookieOptions);
  Cookies.remove(NONCE_COOKIE, cookieOptions);
  Cookies.remove(FANATICS_TENANT_ID_COOKIE, cookieOptions);

  window.location.href = '/';
};

export const useLogout = () => {
  const [logoutSession] = useMutation(logoutMutation);

  const logout = async (baseUrl: string) => {
    const accessToken = Cookies.get(ACCESS_TOKEN_COOKIE);
    const refreshToken = Cookies.get(REFRESH_TOKEN_COOKIE);
    try {
      if (accessToken && refreshToken) {
        await logoutSession({
          variables: {
            accessToken,
            refreshToken,
            terminateSession: true,
          },
        });
      }
    } catch (error) {
      console.log('Failed to log out session');
    }
    collectLogout(baseUrl);
  };

  return { logout };
};
